var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "modal",
    attrs: {
      id: "app-submitted-modal",
      "modal-header": false,
      "modal-dialog-size": "lg",
    },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c("div", { staticClass: "form-page" }, [
              _c("div", { staticClass: "container-main" }, [
                _c("div", { staticClass: "row justify-content-center" }, [
                  _c("div", { staticClass: "col-10" }, [
                    _c("div", { staticClass: "submit-container" }, [
                      _c("h2", { staticClass: "title" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$t("application.textStatus.submitted")) +
                            "!\n              "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "description" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$t(
                                "application-standalone.pages.submit.applicationSubmittedCongrat"
                              )
                            ) +
                            "\n              "
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.hasRequestedDocuments
                        ? _c("p", { staticClass: "description" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$t(
                                    "application-standalone.pages.submit.documentsRequired"
                                  )
                                ) +
                                "\n              "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row justify-content-center" }, [
                  _c(
                    "div",
                    { staticClass: "col-lg-3 col-sm-6 col-10 text-center" },
                    [
                      _c("img", {
                        staticClass: "img-fluid",
                        attrs: {
                          src: require("@Shared/@Assets/img/app-flow/ico-detached.svg"),
                        },
                      }),
                    ]
                  ),
                ]),
                _vm._v(" "),
                !_vm.IS_FILL_OUT
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "row justify-content-center mt-4 app-flow-buttons",
                      },
                      [
                        _c("div", { staticClass: "forward col-auto" }, [
                          _c("a", [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "move-on form-finish btn btn-primary rounded-pill px-4 py-2",
                                on: { click: _vm.handleClick },
                              },
                              [
                                _vm.hasRequestedDocuments
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$t(
                                              "application.actions.continueToDocuments"
                                            )
                                          ) +
                                          "\n                "
                                      ),
                                    ])
                                  : _c("span", [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$t(
                                              "application.actions.continueToPortal"
                                            )
                                          ) +
                                          "\n                "
                                      ),
                                    ]),
                              ]
                            ),
                          ]),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }